<div class="pt-2 gap flex flex-column">

    <div class="flex gap">
        @if (dialogConfig.data.type != SocialServiceProcedureTypeEnum.PROCEDURE) {
            <app-number-input
                #durationNoteInput
                id="durationNote"
                [prefix]="prefix"
                (selectedValueChange)="setValue($event, 'durationNote')"
                [min]="0"
            ></app-number-input>
            <app-number-input
                #durationPreparationInput
                id="durationPreparation"
                [prefix]="prefix"
                (selectedValueChange)="setValue($event, 'durationPreparation')"
                [min]="0"
            ></app-number-input>
            <app-number-input
                #durationSelfReflectionInput
                id="durationSelfReflection"
                [prefix]="prefix"
                (selectedValueChange)="setValue($event, 'durationSelfReflection')"
                [min]="0"
            ></app-number-input>
        }

        <app-tags-input
            id="tags"
            prefix="workData.offer."
            [suggestions]="store.data.searchWorkOfferTags()"
            (queryEvent)="queryTags($event)"
            [showClear]="true"
            (selectedValueChange)="setValue($event, 'tags')"
        ></app-tags-input>
    </div>

    <app-service-pattern-wysiwyg
        [serviceId]="dialogConfig.data.serviceId"
        [form]="form"
        id="note"
        editorKey="socialServiceOfferNoteDialog"
        [usage]="dialogConfig.data.type === SocialServiceProcedureTypeEnum.PROCEDURE
         ? ServicePatternStructureUsageEnum.INDIVIDUAL_WORK_RECORD_OPERATION
         : ServicePatternStructureUsageEnum.INDIVIDUAL_WORK_RECORD_INTERVENTION"
    ></app-service-pattern-wysiwyg>

    @if (durationCheck) {
        <app-warn-float-message
            [closeable]="false"
            [message]="durationCheck"
        ></app-warn-float-message>
    }

</div>
